import { useEffect, useState, useRef } from "react";
import AdSenseAd from "./AdSenseAd"; // 👈 componente que renderiza anuncios reales

const useAdSlots = () => {
  const [adData, setAdData] = useState(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const fetchSlots = async () => {
      const token = localStorage.getItem("access");
      if (!token) return;

      try {
        const res = await fetch("/api/ads/slot/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Error al obtener los ad_slots");
        const data = await res.json();
        setAdData(data);
      } catch (err) {
        // Fallback en caso de error o si la API no responde
        setAdData({
          ad_client: "ca-pub-3940256099942544", // AdSense test client
          slots: [{ slot_key: "adslot_general", ad_slot: "1234567890" }],
        });
      }
    };

    fetchSlots();
  }, []);

  return adData;
};

const contextualMessage = (slotKey) => {
  if (slotKey === "adslot_caa") return "🗣️ Comunicación alternativa y aumentativa (CAA).";
  if (slotKey === "adslot_mobilite") return "🦽 Soluciones de movilidad.";
  if (slotKey === "adslot_sensoriel") return "👁️👂 Soportes sensoriales auditivos y visuales.";
  if (slotKey === "adslot_cognitif") return "🧠 Herramientas para capacidades cognitivas.";
  if (slotKey?.startsWith("adslot_local_")) return "📍 Anuncios geolocalizados para tu comunidad.";
  return "🌍 Anuncios generales para apoyar la plataforma.";
};

const AdBanner = () => {
  const [consent, setConsent] = useState(null);

  // 👇 Verificar consentimiento de cookies
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("cookieConsent");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.advertising === true) {
          setConsent(true);
        }
      }
    } catch (err) {
      console.warn("Consentimiento de cookies no válido:", err);
    }
  }, []);

  const adData = useAdSlots();
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentSlot = adData?.slots?.[currentIndex];

  // Rotación automática de anuncios cada 15s
  useEffect(() => {
    if (!adData || adData.slots.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % adData.slots.length);
    }, 15000);
    return () => clearInterval(interval);
  }, [adData]);

  // 👇 Mostrar solo si hay consentimiento y datos de anuncios
  if (!consent || !adData || !currentSlot) return null;

  return (
    <div className="hidden md:block fixed bottom-0 left-0 w-full bg-white border-t z-40 shadow-md">
      <div className="max-w-5xl mx-auto px-4 py-2 flex flex-col items-center justify-center">
        {/* Bloque real de AdSense */}
        <div
          key={currentSlot.slot_key}
          className="w-[728px] h-[90px] flex items-center justify-center"
        >
          <AdSenseAd
            client={adData.ad_client}
            slot={currentSlot.ad_slot}
          />
        </div>

        {/* Mensaje contextual */}
        <p className="text-xs text-gray-600 mt-1">
          {contextualMessage(currentSlot.slot_key)}
        </p>
      </div>
    </div>
  );
};

export default AdBanner;
